var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIbmAddCommentRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.125L11.0875 18.75L13.225 15H16.25C16.913 15 17.5489 14.7366 18.0178 14.2678C18.4866 13.7989 18.75 13.163 18.75 12.5V5C18.75 4.33696 18.4866 3.70107 18.0178 3.23223C17.5489 2.76339 16.913 2.5 16.25 2.5H3.75C3.08696 2.5 2.45107 2.76339 1.98223 3.23223C1.51339 3.70107 1.25 4.33696 1.25 5V12.5C1.25 13.163 1.51339 13.7989 1.98223 14.2678C2.45107 14.7366 3.08696 15 3.75 15H9.375V13.75H3.75C3.41848 13.75 3.10054 13.6183 2.86612 13.3839C2.6317 13.1495 2.5 12.8315 2.5 12.5V5C2.5 4.66848 2.6317 4.35054 2.86612 4.11612C3.10054 3.8817 3.41848 3.75 3.75 3.75H16.25C16.5815 3.75 16.8995 3.8817 17.1339 4.11612C17.3683 4.35054 17.5 4.66848 17.5 5V12.5C17.5 12.8315 17.3683 13.1495 17.1339 13.3839C16.8995 13.6183 16.5815 13.75 16.25 13.75H12.5L10 18.125ZM9.375 5.625H10.625V8.125H13.125V9.375H10.625V11.875H9.375V9.375H6.875V8.125H9.375V5.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmAddCommentRight);
export default __webpack_public_path__ + "static/media/IBMAddCommentRight.d627afe9.svg";
export { ForwardRef as ReactComponent };